export function Teselia(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      {...props}
    >
      {}
      <g fill="none">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M4 42h40"
        />
        <rect
          width="8"
          height="16"
          x="8"
          y="26"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="4"
          rx="2"
        />
        <path
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M12 34h1"
        />
        <rect
          width="24"
          height="38"
          x="16"
          y="4"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="4"
          rx="2"
        />
        <path
          fill="currentColor"
          d="M22 10h4v4h-4zm8 0h4v4h-4zm-8 7h4v4h-4zm8 0h4v4h-4zm0 7h4v4h-4zm0 7h4v4h-4z"
        />
      </g>
    </svg>
  );
}
